import React from 'react';
import styled from 'styled-components';

const ItemName = (props) => {

  return (
    <StyledTrack
      layout={props.grid_layout}
      className={
        props.grid_layout === 'old'
          ? `f3 item-name card-font-color  `
          : props.grid_layout === 'default'
            ? `f3 custom_item-name card-font-color  `
            : `f3 custom_item-name-new card-font-color  `
      }
    >
      {props.reviewAble && (
        <span className="mr-2">
          <input type="checkbox" checked={props.isChecked} onChange={props.onCheckboxChange} />
        </span>
      )}
      {props.grid_layout === 'old' && props.quantity > 0 && (
        <span className="f2 highlight-color">{props.quantity}x </span>
      )}
      {props.grid_layout !== 'old' && props.quantity > 0 && props._location.quick_button === 0 && (
        <div className={'item-quantity highlight-color-active '}>
          <h4 className='highlight-text-color'>{props.quantity}x</h4>
        </div>
      )}
      {props.grid_layout === 'default' && props.quantity > 0 && props._location.quick_button === 1 && (
        <div className={'item-quantity highlight-color-active '}>
          <h4 className='highlight-text-color'>{props.quantity}x</h4>
        </div>
      )}
      {props.grid_layout === 'old' ? `${props.name}` : <h1 className='card-font-color'>{props.name}</h1>}
    </StyledTrack>
  );
};

let StyledTrack = styled.div`
  p {
    text-transform: capitalize;
    font-size: 16px;
    font-weight: 500 !important;
    line-height: 20px;
    color: #2e2e2e;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: ${(props) =>
    props.layout !== 'old' && props.layout !== 'default' ? `100%` : 'calc(100% - 60px)'};
    max-height: 40px;
  }

  p::first-letter {
    text-transform: uppercase;
  }
`;

export default ItemName;
